import React from 'react';
import classnames from 'classnames';
import s from './ProgressBar.scss';

export interface Props {
  className?: string;
  barClassName?: string;

  /** Percentage having already been multiplied by 100 (e.g. pass `percentage={75}` for 75%) */
  percentage: number;
  color?: string;
  background?: string;
  /** It's important to supply an aria-label so that user's have context for what this progress bar means */
  'aria-label'?: string;
}

class ProgressBar extends React.Component<React.PropsWithChildren<Props>> {
  render() {
    const {
      color,
      background,
      percentage,
      className,
      barClassName,
      children,
      'aria-label': ariaLabel,
    } = this.props;
    const limitedPercentage = Math.min(percentage, 100);
    return (
      <div
        aria-label={ariaLabel}
        role="progressbar"
        aria-valuenow={Math.floor(limitedPercentage)}
        aria-valuemin={0}
        aria-valuemax={100}
        className={classnames(s['root'], className)}
        style={{ background }}
      >
        {children}
        <div
          className={classnames(s['bar'], s['animated'], barClassName)}
          style={{
            background: color,
            transform: `scaleX(${limitedPercentage / 100})`,
            transformOrigin: 'left center',
          }}
          aria-hidden="true"
        />
      </div>
    );
  }
}

export default ProgressBar;
